<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th colspan="18" class="no-border">
            <div class="d-flex justify-content-end">
              <h3 class="pl-3">Nieuws</h3>
            </div>
          </th>
        </tr>
        <tr>
          <th colspan="18" class="no-border">
            <div class="d-flex justify-content-end">
              <button
                @click="filterNews('past')"
                class="btn btn-outline-dark rounded mr-4"
              >
                Historie
              </button>

              <a
                @click="filterNews('upcoming')"
                class="rounded btn btn-md dark-text"
                :class="[
                  !active
                    ? 'btn-dark text-white'
                    : 'btn-outline-dark text-black',
                ]"
                >Aankomend</a
              >
            </div>
          </th>
        </tr>
        <tr>
          <th>Aanmaakdatum</th>
          <th>Titel</th>
          <th>Inhoud</th>
          <th>
            <button
              @click="showFilterInputs = !showFilterInputs"
              class="rounded btn btn-md btn-primary"
            >
              Zoeken
            </button>
          </th>
        </tr>
        <tr v-if="showFilterInputs">
          <th>
            <input type="date" class="form-control" />
          </th>
          <th>
            <input type="text" class="form-control w-50" />
          </th>
          <th>
            <input type="text" class="form-control" />
          </th>
          <th>
            <button
              @click="filterEvent()"
              class="rounded btn btn-md btn-dark text-white"
            >
              Zoeken
            </button>
          </th>
        </tr>
      </thead>
      <thead></thead>
      <tbody>
        <tr v-for="(article, index) in news" :key="index">
          <td>{{ article.created_at }}</td>
          <td>{{ article.title }}</td>
          <td
            v-if="
              (article.public == 1 ||
                checkShowCase(article.user_id, article.committee_id)) &&
                article.content
            "
          >
            {{ article.content | formatSettingContent }}
            <span v-if="article.content.length > 20">...</span>
          </td>
          <td v-else></td>
          <td>
            <a
              v-if="
                article.public == 1 ||
                  checkShowCase(article.user_id, article.committee_id)
              "
              data-toggle="modal"
              data-target="#newsitemModal"
              class="btn btn-sm btn-success text-white"
              @click="editNewItem(article)"
              >Open</a
            >
          </td>
        </tr>
        <tr v-if="loading">
          <td colspan="5" class="text-center">Aan het laden...</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="18">
            <div class="d-flex justify-content-end" v-if="news.length > 0">
              <a
                v-if="current_page != prev_page"
                @click="filterNews('upcoming', prev_page)"
                class="mr-3"
                style="cursor: pointer"
              >
                <i class="fa fa-chevron-left"></i>
              </a>
              <a
                v-if="current_page != next_page"
                @click="filterNews('upcoming', next_page)"
                style="cursor: pointer"
              >
                <i class="fa fa-chevron-right"></i>
              </a>
            </div>
          </th>
        </tr>
      </tfoot>
    </table>

    <div
      class="modal fade"
      id="newsitemModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 1000px">
        <div class="modal-content committee-modal">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <h4 class="modal-title">{{ article.title }}</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <p v-html="article.content"></p>
              </div>
              <div class="col-lg-12">
                <button data-dismiss="modal" class="btn-dark float-right mt-3">
                  Sluiten
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "index",
  components: {},
  computed: {
    ...mapGetters(["isLogged", "userRoles", "userPermissions"]),
  },
  data() {
    return {
      showFilterInputs: false,
      news: [],
      search: {},
      active: 0,
      next_page: 1,
      prev_page: 1,
      loading: false,
      current_page: 1,
      currentUser: {},
      article: {
        id: null,
        content: null,
        title: null,
        active: false,
        public: false,
      },
      saving: false,
    };
  },
  mounted() {
    this.getCurrentUser(this.userRoles[0].id);
  },
  created() {
    this.filterNews("upcoming");
  },
  methods: {
    editNewItem(article) {
      this.article = {
        id: article.id,
        content: article.content,
        title: article.title,
        active: article.active,
        public: article.public,
      };
    },
    filterNews(filter, page = 1) {
      if (this.loading) return false;

      this.loading = true;
      this.active = filter == "upcoming" ? 0 : 1;
      this.$store
        .dispatch("get", `/api/v1/newsitems?filter=${filter}&page=${page}`)
        .then((data) => {
          let news;
          if (this.userHasPermissions(["Beheer Activiteiten"])) {
            news = data.data.data;
            console.log(news);
          } else {
            news = data.data.data.filter((item) => {
              return item.attendees.includes(this.$store.state.auth.user.id);
            });
          }

          this.news = [...news];
          if (data.data.next_page_url != null) {
            this.next_page = data.data.current_page + 1;
          }
          if (data.data.prev_page_url != null) {
            this.prev_page = data.data.current_page + -1;
          }
          this.current_page = data.data.current_page;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error.request);
          this.loading = false;
        });
    },
    getCurrentUser(id) {
      this.$store
        .dispatch("get", "api/v1/users/" + id)
        .then((data) => {
          this.currentUser = { ...data.data.data };
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkShowCase(id, committee_id) {
      if (this.currentUser.id == id) return true;
      else if (this.currentUser.committees) {
        this.currentUser.committees.map((d) => {
          if (d.id == committee_id) {
            return true;
          } else return false;
        });
      } else return false;
    },
  },
  filters: {
    formatDate(value) {
      console.log(value);
      return moment(new Date(value)).format("DD-MM-YYYY HH:mm");
    },
    formatSettingContent(value) {
      return value.replace(/(<([^>]+)>)/gi, "").substring(0, 20);
    },
  },
};
</script>

<style scoped>
.small-size {
  font-size: 0.875rem !important;
}

.no-border {
  border-style: solid;
  border-width: 0px 0px 0px 0px;
}

.committee-modal {
  background: #4192d9;
  color: white;
}
.committee-modal button {
  background: black;
  color: white;
}
</style>
